import { render, staticRenderFns } from "./modalAddCompany.vue?vue&type=template&id=20c6b456&scoped=true&"
import script from "./modalAddCompany.vue?vue&type=script&lang=js&"
export * from "./modalAddCompany.vue?vue&type=script&lang=js&"
import style0 from "./modalAddCompany.vue?vue&type=style&index=0&id=20c6b456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c6b456",
  null
  
)

export default component.exports